import React from 'react'

const AmountSection = ({styles,register,invoice=false}) => {
  return (
    <div className={styles.calculationright}>
              <div className={styles.totalLeft}>
                <div className={styles.amountField}>
                  <label>Fine Metal</label>
                  <input
                    type="text"
                    {...register("TotalFineMetal")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'#fff !important'}}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Paid Metal</label>
                  <input
                    type="text"
                    {...register("TotalPaidMetal")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}
                  />
                </div>

                <div className={styles.amountField}>
                  <label>Balance Metal</label>
                  <input
                    type="text"
                    {...register("TotalBalanceMetal")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Advance Amount</label>
                  <input
                    type="text"
                    {...register("TotalAdvanceAmount")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Paid Amount</label>
                  <input
                    type="text"
                    {...register("TotalPaidAmount")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
              </div>

              <div className={styles.totalRight}>
                <div className={styles.amountField}>
                  <label>Taxable Amount</label>
                  <input
                    type="text"
                    {...register("TotalTaxableAmount")}
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label style={{ display: "flex", alignItems: "center" }}>
                    <label>GST(3%)</label>
                    <input
                      type="checkbox"
                      id="gstCheckbox"
                      disabled={!invoice}
                      style={{
                        width: "15px",
                        height: "15px",
                        border:"1px solid #ddd"
                        // cursor: "pointer",
                      }}
                      {...register("gstCheckbox")}
                    />
                  </label>
                  <input
                    type="text"
                    disabled={true}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                    {...register("TotalGst")}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>R.O./Discount(-)</label>
                  <input
                   step="0.01"
                    type="number"
                    {...register("TotalRODiscount")}
                    style={{border:'1px solid #ddd',backgroundColor:'#fff !important'}}

                    // disabled={true}
                  />
                </div>
                <div className={styles.amountField}>
                  <label>Total Amount</label>
                  <input
                    type="text"
                    disabled={true}
                    {...register("TotalBillAmount")}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
                <div className={styles.amountField}>
                  <label>Balance Amount</label>
                  <input
                    type="text"
                    disabled={true}
                    {...register("TotalBalanceAmount")}
                    style={{border:'1px solid #ddd',backgroundColor:'white !important'}}

                  />
                </div>
              </div>
            </div>
  )
}

export default AmountSection
